import PressDNSLogo from "../../../../src/images/services/pressdns.svg";
import * as React from 'react';
export default {
  PressDNSLogo,
  React
};